import { downgradeInjectable } from '@angular/upgrade/static';
import { ApiService } from '@mode/shared/util-halogen';
import * as angular from 'angular';
import { DowngradedAngularCommonModule } from '../downgraded-modules/common.module';
import { DowngradedSharedDataAccessModelJsModule } from '../downgraded-modules/data-access-model-js.module';
import { DeprecatedApiService } from './api.service';
import { ModeLinkFactoryMigrationAdapter, ModeLinkFactoryService } from './mode-link.factory';
import { ModeResourceFactoryMigrationAdapter, ModeResourceFactoryService } from './mode-resource.factory';

const API_DEPS = [DowngradedAngularCommonModule, DowngradedSharedDataAccessModelJsModule];

const modeApiModule = angular.module('mode.api', API_DEPS);

modeApiModule
  .service('ApiService', downgradeInjectable(DeprecatedApiService))
  .service('ApiServiceNg2', downgradeInjectable(ApiService))
  .service('ModeLinkFactory', downgradeInjectable(ModeLinkFactoryService))
  .service('ModeResourceFactory', downgradeInjectable(ModeResourceFactoryService))
  .factory('ModeResource', ModeResourceFactoryMigrationAdapter)
  .factory('ModeLink', ModeLinkFactoryMigrationAdapter);

export const ApiModule = modeApiModule.name;
